import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
// FIXME this dependency should be reviewed it causes an app crash
import { ProgressBarButtonModule } from '../../../../../iot-platform/iot-platform-ui/src/lib/components/progress-bar-button/progress-bar-button.module';

import { AuthValidators } from '../../validators/auth.validator';
import { LoginPasswordRulesComponent } from '../login-password-rules/login-password-rules.component';

@Component({
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInput,
    MatButtonModule,
    LoginPasswordRulesComponent,
    ProgressBarButtonModule
  ],
  selector: 'iot-platform-login-change-temporary-password-form',
  templateUrl: './login-change-temporary-password-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./login-change-temporary-password-form.component.scss', '../../scss/style.scss']
})
export class LoginChangeTemporaryPasswordFormComponent {
  /** Error message of the failed password change (e.g. the raw Cognito message), if any. */
  hasError = input<string>();
  // eslint-disable-next-line  @angular-eslint/no-output-native
  cancel = output();
  changeTemporaryPassword = output<string>();

  form: FormGroup<{ newPassword: FormControl<string | null>; confirmNewPassword: FormControl<string | null> }>;

  enableGauge: WritableSignal<boolean> = signal(false);
  password: WritableSignal<string | null> = signal(null);

  constructor() {
    this.form = new FormGroup({
      newPassword: new FormControl<string | null>(null, [Validators.required, AuthValidators.checkPassword]),
      confirmNewPassword: new FormControl<string | null>(null, [Validators.required, this.checkConfirmPassword.bind(this)])
    });
  }

  get newPassword(): FormControl<string | null> {
    return this.form.controls.newPassword;
  }

  get confirmNewPassword(): FormControl<string | null> {
    return this.form.controls.confirmNewPassword;
  }

  sendPasswordToRules(value: string | null): void {
    this.password.set(value);
  }

  checkConfirmPassword(confirmPassword: AbstractControl): ValidationErrors | null {
    if (!this.form) {
      return null;
    }
    return confirmPassword.value === this.form.controls.newPassword.value ? null : { different: true };
  }

  onCancel() {
    this.cancel.emit();
  }

  onChangeTemporaryPassword() {
    this.changeTemporaryPassword.emit(this.newPassword.value ?? '');
  }
}
